import { ReactNode } from 'react'
import clsx from 'clsx'

interface CardProps {
  children: ReactNode
  className?: string
  title?: string
  actions?: ReactNode
  onClick?: () => void
}

export default function Card({ children, className, title, actions, onClick }: CardProps) {
  return (
    <div className={clsx('card', className)} onClick={onClick} style={onClick ? { cursor: 'pointer' } : undefined}>
      {(title || actions) && (
        <div className="flex justify-between items-center mb-4">
          {title && <h3 className="text-lg font-semibold">{title}</h3>}
          {actions && <div className="flex space-x-2">{actions}</div>}
        </div>
      )}
      {children}
    </div>
  )
}
